export type VolumeDatafyAction = 'datafy' | 'undatafy';

/**
 * Single-volume datafy endpoints require ?accounts=<child-uuid> in org context.
 * Do not use accounts=all for single-resource POST calls.
 */
export function buildVolumeDatafyUrl(
  volumeId: string,
  action: VolumeDatafyAction,
  accountId?: string
): string {
  const params = new URLSearchParams();
  if (accountId) {
    params.set('accounts', accountId);
  }
  const query = params.size ? `?${params.toString()}` : '';
  return `/api/v1/volumes/${volumeId}/${action}${query}`;
}
